import { getProviderDefinition, validateScriptOrigin } from '../provider-allowlist.js';
export class ProviderScriptAdapter {
    provider = 'PROVIDER_SCRIPT';
    isLoaded = false;
    load(integration, ctx) {
        if (typeof window === 'undefined' || this.isLoaded)
            return;
        const definition = getProviderDefinition(integration.provider);
        const src = integration.configuration.src;
        if (typeof src !== 'string' || src.length === 0) {
            ctx.logger.warn('ProviderScript adapter: missing src', { integrationId: integration.id });
            return;
        }
        if (definition === undefined) {
            ctx.logger.warn('ProviderScript adapter: unknown provider', {
                provider: integration.provider,
            });
            return;
        }
        if (validateScriptOrigin(definition, src) === null) {
            ctx.logger.warn('ProviderScript adapter: invalid or disallowed src', {
                integrationId: integration.id,
                src,
            });
            return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.async = integration.configuration.async !== false;
        script.defer = integration.configuration.defer === true;
        script.crossOrigin = integration.configuration.crossOrigin || 'anonymous';
        script.type = integration.configuration.type || 'text/javascript';
        const integrity = integration.configuration.integrity;
        if (typeof integrity === 'string' && integrity.length > 0) {
            script.integrity = integrity;
        }
        script.onerror = () => {
            this.isLoaded = false;
            ctx.logger.warn('ProviderScript adapter: script load failed', {
                integrationId: integration.id,
            });
        };
        script.onload = () => {
            this.isLoaded = true;
        };
        document.head.appendChild(script);
    }
    track(_event, _integration, _ctx) {
        // Managed provider scripts do not receive events by default.
        // Adapters may be extended to call vendor APIs explicitly.
    }
}
//# sourceMappingURL=provider-script-adapter.js.map